var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "order-return-review-customer-details flex flex-auto flex-col",
    },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v("\n    Customer Details\n  "),
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { "margin-top": "24px" } }, [
        _c("div", { staticClass: "section-header" }, [
          _c("div", { staticClass: "flex-1" }, [
            _vm._v("\n        Customer Details\n      "),
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "edit-details-link",
              on: {
                click: function ($event) {
                  return _vm.$emit("update:editDetails", true)
                },
              },
            },
            [_vm._v("\n        Edit Customer Details\n      ")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "return-customer-details" },
        [
          _c("el-card", { attrs: { shadow: "never" } }, [
            _c("div", { staticClass: "flex flex-col" }, [
              _c("div", { staticClass: "flex flex-row" }, [
                _c("div", { staticClass: "flex-1" }, [
                  _vm._v("\n            Name\n          "),
                ]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.customer.customer_name))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-row" }, [
                _c("div", { staticClass: "flex-1" }, [
                  _vm._v("\n            Phone Number\n          "),
                ]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.customer.customer_phone))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-row" }, [
                _c("div", { staticClass: "flex-1" }, [
                  _vm._v("\n            Email\n          "),
                ]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.customer.customer_email))]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "flex flex-row",
                  staticStyle: { "margin-top": "20px" },
                },
                [
                  _c("div", { staticClass: "flex-1" }, [
                    _vm._v("\n            Street\n          "),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.address.address_1) +
                        " " +
                        _vm._s(_vm.address.address_2)
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-row" }, [
                _c("div", { staticClass: "flex-1" }, [
                  _vm._v("\n            City\n          "),
                ]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.address.city))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-row" }, [
                _c("div", { staticClass: "flex-1" }, [
                  _vm._v("\n            State/province/area\n          "),
                ]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.address.state))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-row" }, [
                _c("div", { staticClass: "flex-1" }, [
                  _vm._v("\n            Zip code\n          "),
                ]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.address.zip))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-row" }, [
                _c("div", { staticClass: "flex-1" }, [
                  _vm._v("\n            Country\n          "),
                ]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.address.country))]),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "return-customer-details" },
        [
          _c("el-card", { attrs: { shadow: "never" } }, [
            _c(
              "div",
              { staticClass: "flex flex-col" },
              [
                _c("div", { staticClass: "flex flex-row" }, [
                  _c("div", { staticClass: "flex-1" }, [
                    _vm._v("\n            State Tax\n          "),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      _vm._s(
                        _vm.formattedAmount(
                          _vm.totalTax.amount,
                          _vm.totalTax.currency_code
                        )
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-row" }, [
                  _c("div", { staticClass: "flex-1" }, [
                    _vm._v("\n            Additional fees\n          "),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      _vm._s(
                        _vm.formattedAmount(
                          _vm.additionalFees,
                          _vm.totalTax.currency_code
                        )
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("el-divider"),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-row" }, [
                  _c("div", { staticClass: "flex-1" }, [
                    _vm._v("\n            Total refund\n          "),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      _vm._s(
                        _vm.formattedAmount(
                          _vm.refundInfo.amount,
                          _vm.refundInfo.currency
                        )
                      )
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-top": "16px" } }, [
      _c("div", { staticClass: "section-header" }, [
        _vm._v("\n      Payment\n    "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }